module.exports = __webpack_public_path__ + "img/FreddyTheLawnFlamingo_EGM.410c0df4.jpg";